import { useContext } from 'react';
import ChartDefinitions, {
  ContextType,
} from '@components/ChartDefinitionsContext';

export default function useChartDefinitions(): ContextType {
  const ChartDefinitionsContext = useContext(ChartDefinitions);
  return ChartDefinitionsContext || {};
}
